export default __webpack_public_path__ + "static/media/flag-us.1d129c24.png";